import {
  SORT_OSPEDALE_API,
  ID_OSPEDALE_API,
  ID_OSPEDALE_JSON,
  NOME_OSPEDALE_API,
  NOME_OSPEDALE_JSON,
  INDIRIZZO_OSPEDALE_API,
  INDIRIZZO_OSPEDALE_JSON,
  CIVICO_OSPEDALE_API,
  CIVICO_OSPEDALE_JSON,
  CAP_OSPEDALE_API,
  CAP_OSPEDALE_JSON,
  COMUNE_OSPEDALE_API,
  COMUNE_OSPEDALE_JSON,
  PROVINCIA_OSPEDALE_API,
  PROVINCIA_OSPEDALE_JSON,
  NOME_OSPEDALE_BREVE_JSON,
  NOME_OSPEDALE_BREVE_API,
} from "./constants";

export const preparaListaPs = (data) => {
  if (data) {
    return data
      .sort((a, b) => (a[SORT_OSPEDALE_API] > b[SORT_OSPEDALE_API] ? 1 : a[SORT_OSPEDALE_API] < b[SORT_OSPEDALE_API] ? -1 : 0))
      .map((ps) => ({
        [ID_OSPEDALE_JSON]: ps[ID_OSPEDALE_API],
        [NOME_OSPEDALE_JSON]: ps[NOME_OSPEDALE_API],
        [NOME_OSPEDALE_BREVE_JSON]: ps[NOME_OSPEDALE_BREVE_API],
        [INDIRIZZO_OSPEDALE_JSON]: ps[INDIRIZZO_OSPEDALE_API],
        [CIVICO_OSPEDALE_JSON]: ps[CIVICO_OSPEDALE_API],
        [CAP_OSPEDALE_JSON]: ps[CAP_OSPEDALE_API],
        [COMUNE_OSPEDALE_JSON]: ps[COMUNE_OSPEDALE_API],
        [PROVINCIA_OSPEDALE_JSON]: ps[PROVINCIA_OSPEDALE_API],
      }));
  } else return data;
};
